import styled from 'styled-components';

export const Root = styled('h2')`
  font-size: ${({ theme }) => theme.fontSize(16)} !important;
  line-height: ${({ theme }) => theme.fontSize(17.6)} !important;
  font-weight: 700 !important;
`;
